// extracted by mini-css-extract-plugin
export default {"wrapper":"LocalIdsListCell_wrapper__Y-tln","listWrapper":"LocalIdsListCell_listWrapper__oWj4O","viewButton":"LocalIdsListCell_viewButton__J2kK2"};